import React from "react";
import { withBBCodeMapper } from "../../util/hoc/withBBCode";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function FieldTemplate(_ref) {
  var _uiSchema$uiBefore, _uiSchema$uiStart, _uiSchema$uiEnd, _uiSchema$uiAfter;
  var id = _ref.id,
    classNames = _ref.classNames,
    label = _ref.label,
    children = _ref.children,
    errors = _ref.errors,
    help = _ref.help,
    rawHelp = _ref.rawHelp,
    description = _ref.description,
    hidden = _ref.hidden,
    required = _ref.required,
    displayLabel = _ref.displayLabel,
    uiSchema = _ref.uiSchema;
  if (hidden) return children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(_uiSchema$uiBefore = uiSchema["ui:before"]) !== null && _uiSchema$uiBefore !== void 0 ? _uiSchema$uiBefore : null, /*#__PURE__*/_jsxs("div", {
      className: classNames,
      children: [(_uiSchema$uiStart = uiSchema["ui:start"]) !== null && _uiSchema$uiStart !== void 0 ? _uiSchema$uiStart : null, displayLabel && /*#__PURE__*/_jsx(Label, {
        label: label,
        required: required,
        id: id
      }), displayLabel && description ? description : null, children, errors, rawHelp ? /*#__PURE__*/_jsx(Help, {
        help: rawHelp
      }) : help, (_uiSchema$uiEnd = uiSchema["ui:end"]) !== null && _uiSchema$uiEnd !== void 0 ? _uiSchema$uiEnd : null]
    }), (_uiSchema$uiAfter = uiSchema["ui:after"]) !== null && _uiSchema$uiAfter !== void 0 ? _uiSchema$uiAfter : null]
  });
}
var Label = withBBCodeMapper("label")(function (_ref2) {
  var id = _ref2.id,
    label = _ref2.label;
  if (!label) return /*#__PURE__*/_jsx("div", {});
  return /*#__PURE__*/_jsx("label", {
    className: "control-label",
    htmlFor: id,
    children: label
  });
});
var Help = withBBCodeMapper("help")(function (_ref3) {
  var help = _ref3.help;
  return help && /*#__PURE__*/_jsx("div", {
    className: "help-block",
    children: help
  }) || null;
});
export default FieldTemplate;
//# sourceMappingURL=FieldTemplate.js.map